<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="manage-statuses"/>
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="map-marker-alt"></b-icon>
              <span> {{ $t('statuses_list') }} </span>
            </template>
            <div>
              <project-statuses-manual
                ref="project_locations_manual"
                :project-id="projectId"
                :is-admin-locations="true"
              />
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProjectStatusesManual from '../../components/project-statuses-manual'
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'

  export default {
    middleware: 'auth',
    title: 'manage_statuses_page_title',
    menuOption: '0-2',

    components: {
      ProjectStatusesManual,
      ProjectAdminQuickButtons
    },

    computed: {
      ...mapGetters({
        navData: "app/navData",
      }),
      projectId() {
        return parseInt(this.$route.params.project_id)
      },
    },

    data: () => ({
      mainActiveTab: 0
    }),

    watch: {
      mainActiveTab(value) {
        if (value == 0) {
          this.$refs.project_locations_manual.reload()
        }
      }
    },

    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];
    },

    methods: {}
  };
</script>
